var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "home-screen" },
        [
          _c("div", { ref: "bg", staticClass: "bg-home-screen" }),
          _vm._v(" "),
          _c("home-header"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home-screen-body" },
            [_vm._m(0), _vm._v(" "), _c("home-search")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home-body" },
        [
          _c(
            "div",
            { ref: "pending" },
            _vm._l(_vm.pendingData, function(item, index) {
              return _c(
                "hotel-block",
                _vm._b({ key: index }, "hotel-block", item, false)
              )
            })
          ),
          _vm._v(" "),
          _c("home-banner"),
          _vm._v(" "),
          _c("top-deals"),
          _vm._v(" "),
          _c("rec-city"),
          _vm._v(" "),
          _c("ebbly-info")
        ],
        1
      ),
      _vm._v(" "),
      _c("home-footer"),
      _vm._v(" "),
      _c("sign-up"),
      _vm._v(" "),
      _c("home-login"),
      _vm._v(" "),
      _c("home-forget")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "h1" }, [
      _vm._v("\n                Book the\n                "),
      _c("img", {
        staticClass: "best-ebbly",
        attrs: { src: require("../../assets/best.png") }
      }),
      _vm._v(" for Your Trip\n            ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d6cfa50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d6cfa50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/Home.vue
// module id = null
// module chunks = 